// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
  height: 100%;
}

.map-container {
  width: 95vw;
  height: 60vh;
}

h2 {
  font-size: 2rem;
}

p {
  font-size: 1.5rem;
}

a {
  font-size: 1.5rem;
}

.map-form-input {
  background-color: #e5e7ebe2;
  border: none;
  /* text-transform: uppercase; */
  font-size: 1.6rem;
  border-radius: 100rem;
  transition: 0.3s;
  padding: 1rem 2rem;
  justify-content: center;
  align-items: center;
  width: 30rem;
  margin: 10px;
}

.map-form-button {
  background-color: #e5e7ebe2;
  border: none;
  text-transform: uppercase;
  font-size: 1.6rem;
  border-radius: 100rem;
  cursor: pointer;
  transition: 0.3s;
  padding: 1rem 2rem;
  justify-content: center;
  align-items: center;
  width: 30rem;
  margin: 10px;
}

.map-form-button:hover {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: scale(1.05);
}

.popup-container {
  font-family: "Inter";
  display: flex;
  flex-direction: column;
}

.popup-details-container {
  align-items: center;
}

.popup-button-container {
  display: flex;
  margin-top: 3rem;
}

.popup-button {
  text-align: center;
  background-color: #e5e7ebe2;
  border: none;
  text-transform: uppercase;
  font-size: 1.3rem;
  border-radius: 100rem;
  cursor: pointer;
  transition: 0.3s;
  padding: 1rem 2rem;
  justify-content: center;
  align-items: center;
  width: 25rem;
  margin: auto;
}

.popup-button:hover {
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  transform: scale(1.05);
}

@media (max-width: 1077px) {
  form {
    display: flex;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Map/Map.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;AACF","sourcesContent":[".map-page {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4rem;\n  height: 100%;\n}\n\n.map-container {\n  width: 95vw;\n  height: 60vh;\n}\n\nh2 {\n  font-size: 2rem;\n}\n\np {\n  font-size: 1.5rem;\n}\n\na {\n  font-size: 1.5rem;\n}\n\n.map-form-input {\n  background-color: #e5e7ebe2;\n  border: none;\n  /* text-transform: uppercase; */\n  font-size: 1.6rem;\n  border-radius: 100rem;\n  transition: 0.3s;\n  padding: 1rem 2rem;\n  justify-content: center;\n  align-items: center;\n  width: 30rem;\n  margin: 10px;\n}\n\n.map-form-button {\n  background-color: #e5e7ebe2;\n  border: none;\n  text-transform: uppercase;\n  font-size: 1.6rem;\n  border-radius: 100rem;\n  cursor: pointer;\n  transition: 0.3s;\n  padding: 1rem 2rem;\n  justify-content: center;\n  align-items: center;\n  width: 30rem;\n  margin: 10px;\n}\n\n.map-form-button:hover {\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1.05);\n}\n\n.popup-container {\n  font-family: \"Inter\";\n  display: flex;\n  flex-direction: column;\n}\n\n.popup-details-container {\n  align-items: center;\n}\n\n.popup-button-container {\n  display: flex;\n  margin-top: 3rem;\n}\n\n.popup-button {\n  text-align: center;\n  background-color: #e5e7ebe2;\n  border: none;\n  text-transform: uppercase;\n  font-size: 1.3rem;\n  border-radius: 100rem;\n  cursor: pointer;\n  transition: 0.3s;\n  padding: 1rem 2rem;\n  justify-content: center;\n  align-items: center;\n  width: 25rem;\n  margin: auto;\n}\n\n.popup-button:hover {\n  cursor: pointer;\n  transition: transform 0.3s ease-in-out;\n  transform: scale(1.05);\n}\n\n@media (max-width: 1077px) {\n  form {\n    display: flex;\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
